import api from './base';

/**
 * Get all products with filtering and pagination
 */
export const getProducts = async (params = {}) => {
  const response = await api.get('/products', { params });
  return response.data;
};

/**
 * Get product details by ID
 */
export const getProductDetails = async (productId) => {
  const response = await api.get(`/products/${productId}`);
  return response.data;
};

/**
 * Get featured products
 */
export const getFeaturedProducts = async (params = {}) => {
  const response = await api.get('/products/featured', { params });
  return response.data;
};

/**
 * Get new arrivals — reuses /products endpoint sorted by newest first
 */
export const getNewArrivals = async (params = {}) => {
  const response = await api.get('/products', {
    params: {
      sortBy: 'createdAt',
      sortOrder: 'desc',
      ...params
    }
  });
  return response.data;
};

/**
 * Get products by category
 */
export const getProductsByCategory = async (category, params = {}) => {
  const response = await api.get(`/products/category/${category}`, { params });
  return response.data;
};

/**
 * Search products
 */
export const searchProducts = async (query, params = {}) => {
  const response = await api.get('/products/search', {
    params: { q: query, ...params }
  });
  return response.data;
};

/**
 * Get related products
 */
export const getRelatedProducts = async (productId, params = {}) => {
  const response = await api.get(`/products/${productId}/related`, { params });
  return response.data;
};

/**
 * Get all product categories
 */
export const getCategories = async () => {
  const response = await api.get('/products/categories');
  return response.data;
};

/**
 * Get available product colors
 */
export const getProductColors = async () => {
  const response = await api.get('/products/colors');
  return response.data;
};

/**
 * Get products by color
 */
export const getProductsByColor = async (color, params = {}) => {
  const response = await api.get(`/products/color/${color}`, { params });
  return response.data;
};

/**
 * Get products by brand
 */
export const getProductsByBrand = async (brand, params = {}) => {
  const response = await api.get(`/products/brand/${brand}`, { params });
  return response.data;
};